var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNondoxNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    fill: "#CD9F61",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.58325V10.4999M5.25 7.58325C5.25 9.37088 5.25 13.2849 5.25 13.5107C5.25 14.3171 6.38496 14.7966 8.65488 15.7555C9.56678 16.1406 10.0227 16.3333 10.5 16.3333V10.1236",
    stroke: "#A97835",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14.5833C12.25 14.5833 12.7604 14.5833 13.2708 15.75C13.2708 15.75 14.8922 12.8333 16.3333 12.25",
    stroke: "#A97835",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35679 9.15339L6.65275 8.32883C5.71758 7.87631 5.25 7.65005 5.25 7.29175C5.25 6.93345 5.71758 6.70719 6.65275 6.25467L8.35679 5.43011C9.40847 4.9212 9.93434 4.66675 10.5 4.66675C11.0657 4.66675 11.5915 4.9212 12.6432 5.43011L14.3473 6.25467C15.2824 6.70719 15.75 6.93345 15.75 7.29175C15.75 7.65005 15.2824 7.87631 14.3473 8.32883L12.6432 9.15339C11.5915 9.6623 11.0657 9.91675 10.5 9.91675C9.93434 9.91675 9.40847 9.6623 8.35679 9.15339Z",
    stroke: "#A97835",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5L8.16667 11.0833",
    stroke: "#A97835",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4166 5.83325L7.58325 8.74992",
    stroke: "#A97835",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNondoxNew);
export default __webpack_public_path__ + "static/media/nondox-new.66f25b4d3fabe4fbe10093fe55e72ca2.svg";
export { ForwardRef as ReactComponent };